var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4099 12.0006L16.9999 8.44064C17.1909 8.24703 17.2971 7.9855 17.2952 7.71357C17.2933 7.44164 17.1835 7.1816 16.9899 6.99064C16.7963 6.79969 16.5348 6.69346 16.2628 6.69534C15.9909 6.69721 15.7309 6.80703 15.5399 7.00064L11.9999 10.5906L8.45992 7.07064C8.27256 6.88439 8.0191 6.77985 7.75492 6.77985C7.49073 6.77985 7.23728 6.88439 7.04992 7.07064C6.95619 7.16361 6.8818 7.27421 6.83103 7.39607C6.78026 7.51792 6.75412 7.64863 6.75412 7.78064C6.75412 7.91265 6.78026 8.04336 6.83103 8.16522C6.8818 8.28708 6.95619 8.39768 7.04992 8.49064L10.5899 12.0006L6.99992 15.5606C6.80896 15.7543 6.70274 16.0158 6.70461 16.2877C6.70649 16.5596 6.81631 16.8197 7.00992 17.0106C7.20353 17.2016 7.46506 17.3078 7.73699 17.3059C8.00892 17.3041 8.26896 17.1943 8.45992 17.0006L11.9999 13.4106L15.5399 16.9306C15.7273 17.1169 15.9807 17.2214 16.2449 17.2214C16.5091 17.2214 16.7626 17.1169 16.9499 16.9306C17.0436 16.8377 17.118 16.7271 17.1688 16.6052C17.2196 16.4834 17.2457 16.3527 17.2457 16.2206C17.2457 16.0886 17.2196 15.9579 17.1688 15.8361C17.118 15.7142 17.0436 15.6036 16.9499 15.5106L13.4099 12.0006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovedImg);
export default __webpack_public_path__ + "static/media/removed-img.226911d9dfac7286bdf9f881c0addf2c.svg";
export { ForwardRef as ReactComponent };